import "react-toastify/dist/ReactToastify.css";
import "./app.scss";
import { Routes, Route } from "react-router-dom";
import AdminLayout from "./layouts/AdminLayout";
import PublicLayout from "./layouts/PublicLayout";
import HomePage from "./pages/Home/HomePage";
import SignupPage from "./pages/User/SignupPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import UsersPage from "./pages/User/UsersPage";
import NotFoudPage from "./pages/404/NotFoudPage";
import CreateUserPage from "./pages/User/CreateUserPage";
import UserProfilePage from "./pages/User/UserProfilePage";

import UpdateUserPage from "./pages/User/UpdateUserPage";
import UserScoringStatsPage from "./pages/User/UserScoringStatsPage";

import { AuthProvider } from "./contexts/AuthContext";

import LoginPage from "./pages/Home/LoginPage";
import CreateCandidaturePage from "./pages/Candidature/CreateCandidaturePage";
import CompetitorDashboardPage from "./pages/Dashboard/CompetitorDashboardPage";
import ViewCandidaturePage from "./pages/Candidature/ViewCandidaturePage";
import UpdateCandidaturePage from "./pages/Candidature/UpdateCandidaturePage";
import ListCandidaturesPage from "./pages/Candidature/ListCandidaturesPage";
import SubmittedCandidaturePage from "./pages/Candidature/SubmittedCandidaturePage";
import CreateSelfKnowledgeQuestionnairePage from "./pages/Candidature/CreateSelfKnowledgeQuestionnairePage";
import ViewSelfKnowledgeQuestionnairePage from "./pages/Candidature/ViewSelfKnowledgeQuestionnairePage";
import ForgotPasswordPage from "./pages/Home/ForgotPasswordPage";
import EnrollmentOfficerPage from "./pages/Candidature/EnrollmentOfficerPage";
import CandidaturesByDistrictPage from "./pages/Candidature/CandidaturesByDistrictPage";
import ScoreApplicationPage from "./pages/Candidature/ScoreApplicationPage";
import JuryCandidaturesPage from "./pages/Candidature/JuryCandidaturesPage";
import RankingCandidaturesPage from "./pages/Candidature/RankingCandidaturesPage";
import CreatePrototypePage from "./pages/Prototype/CreatePrototypePage";
import ListPrototypesPage from "./pages/Prototype/ListPrototypesPage";
import ViewPrototypePage from "./pages/Prototype/ViewPrototypePage";
import JuryPrototypesPage from "./pages/Prototype/JuryPrototypesPage";
import ScorePrototypePage from "./pages/Prototype/ScorePrototypePage";
import PrototypeJuryStatsPage from "./pages/Prototype/PrototypeJuryStatsPage";
import RankingPrototypesPage from "./pages/Prototype/RankingPrototypesPage";

function App() {
  return (
    <>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<PublicLayout />}>
            <Route path="/" element={<HomePage />}></Route>
            <Route path="adm" element={<LoginPage />} />
            <Route path="regista-te" element={<SignupPage />} />
            <Route path="esqueceu-a-senha" element={<ForgotPasswordPage />} />
          </Route>
          <Route path="/admin/*" element={<AdminLayout />}>
            <Route path="home" element={<CompetitorDashboardPage />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route
              path="create-candidature"
              element={<CreateCandidaturePage />}
            />
            <Route path="candidature/:uuid" element={<ViewCandidaturePage />} />
            <Route
              path="update-candidature/:uuid"
              element={<UpdateCandidaturePage />}
            />
            <Route
              path="create-self-knowledge-questionnaire/:uuid"
              element={<CreateSelfKnowledgeQuestionnairePage />}
            />
            <Route
              path="candidatures-by-jury"
              element={<JuryCandidaturesPage />}
            />
            <Route
              path="candidatures-ranking"
              element={<RankingCandidaturesPage />}
            />
            <Route
              path="pontuar-candidatura/:uuid"
              element={<ScoreApplicationPage />}
            />
            <Route
              path="self-knowledge-questionnaire/:uuid"
              element={<ViewSelfKnowledgeQuestionnairePage />}
            />
            <Route
              path="submitted-candidature/:uuid"
              element={<SubmittedCandidaturePage />}
            />
            <Route path="candidatures" element={<ListCandidaturesPage />} />
            <Route
              path="enrollment-officers"
              element={<EnrollmentOfficerPage />}
            />
            <Route
              path="candidatures-by-district"
              element={<CandidaturesByDistrictPage />}
            />
            <Route path="prototype" element={<CreatePrototypePage />} />
            <Route path="prototypes" element={<ListPrototypesPage />} />
            <Route path="prototype/:uuid" element={<ViewPrototypePage />} />
            <Route path="jury-prototypes" element={<JuryPrototypesPage />} />
            <Route path="score-prototype/:uuid" element={<ScorePrototypePage />} />
            <Route path="prototype-jury-stats" element={<PrototypeJuryStatsPage />} />
            <Route path="prototypes-ranking" element={<RankingPrototypesPage />} />
            <Route path="utilizadores" element={<UsersPage />} />
            <Route path="registar-utilizador" element={<CreateUserPage />} />
            <Route
              path="actualizar-utilizador/:username"
              element={<UpdateUserPage />}
            />
            <Route path="minha-conta" element={<UserProfilePage />} />
            <Route
              path="estatisticas-pontuacao"
              element={<UserScoringStatsPage />}
            />
          </Route>
          <Route path="*" element={<NotFoudPage />} />
        </Routes>
      </AuthProvider>
    </>
  );
}

export default App;
